import React from "react";

import { trackMixpanel } from "utils";

import { HIDE_COMMUNITY } from "consts";

import { Divider, Drawer, HideFeature, Icon, Link } from "components";

const CTADrawerItem = ({ icon: CtaIcon, label }) => (
  <div className="menu-item" onClick={() => trackMixpanel("ClickCTAMenuLink", { link: label })}>
    {CtaIcon}
    <span>{label}</span>
  </div>
);

export const CTADrawerMobile = ({ dynamicNavLink, translations, visible, onClose }) => {
  trackMixpanel("OpenCTAMenuMenu", {});

  return (
    <Drawer
      className="bottom-drawer"
      closable={true}
      height={dynamicNavLink ? "15rem" : "10.5rem"}
      placement="bottom"
      visible={visible}
      onClose={onClose}
      destroyOnHidden={true}
    >
      <div className="bottom-drawer-handle" onClick={onClose}>
        <div />
      </div>
      {dynamicNavLink && (
        <>
          <Link to={dynamicNavLink.link} mixpanelText={dynamicNavLink.label}>
            <CTADrawerItem icon={<Icon iconName="tabler/apps" size="m" />} label={dynamicNavLink.label} />
          </Link>
          <Divider />
        </>
      )}
      <Divider />
      <HideFeature hide={HIDE_COMMUNITY}>
        <Link to="/community/add" mixpanelText={translations.startThread}>
          <CTADrawerItem icon={<Icon iconName="tabler/message-plus" size="m" />} label={translations.startThread} />
        </Link>
      </HideFeature>
    </Drawer>
  );
};
